import ModalCommisions from './ModalCommisions'

export default ModalCommisions
